export const CAPSTONE = 'capstone';
export default CAPSTONE;
